export default {
  PRODUCT_CENTER: 'https://project.hrtps.com',
  baseURL: '/gateway',
  COS: {
    bucket: 'chatbot-prod-1256119856',
    region: 'ap-shanghai'
  }
};
